import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  CreateOrderDto,
  EnterpriseOrdersApi,
  UpdateOrderDto,
} from '../api-client';
import { message } from 'antd/lib';
import axios from 'axios';

const enterpriseOrderApi = new EnterpriseOrdersApi();

export function useEnterpriseOrders(data: {
  params: Parameters<
    typeof enterpriseOrderApi.enterpriseOrderControllerGetOrders
  >;
}) {
  return useQuery(['enterpriseOrders', data], async () => {
    return enterpriseOrderApi
      .enterpriseOrderControllerGetOrders(...data.params)
      .then((res) => res.data);
  });
}

export function useCreateEnterpriseOrder() {
  const queryClient = useQueryClient();

  return useMutation(
    ['createEnterpriseOrder'],
    (data: CreateOrderDto) => {
      return enterpriseOrderApi.enterpriseOrderControllerCreateOrder(data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('enterpriseOrders');
        message.success('新增成功');
      },
    }
  );
}

export function useUpdateEnterpriseOrder() {
  const queryClient = useQueryClient();

  return useMutation(
    ['enterpriseOrders', 'update'],
    (data: { id: string } & UpdateOrderDto) => {
      const { id, ...updateData } = data;
      return enterpriseOrderApi.enterpriseOrderControllerUpdateOrder(
        id,
        updateData
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('enterpriseOrders');
        message.success('更新成功');
      },
    }
  );
}

export function useDeleteEnterpriseOrder() {
  const queryClient = useQueryClient();

  return useMutation(
    ['enterpriseOrders', 'delete'],
    (id: string) => {
      return enterpriseOrderApi.enterpriseOrderControllerDeleteOrder(id);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('enterpriseOrders');
        message.success('刪除成功');
      },
    }
  );
}

export function useExportEnterpriseStatement() {
  return useMutation(
    ['enterpriseOrders', 'export'],
    (data: { id: string; name: string; date: string }) => {
      return axios
        .get(`/enterprise-orders/${data.id}/export-enterprise-statement`, {
          responseType: 'blob',
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', `${data.date} ${data.name}請款單.pdf`); // 指定下載的檔名

          document.body.appendChild(link);

          link.click();
          link.remove();

          window.URL.revokeObjectURL(url);
        });
    },
    {
      onSuccess: () => {
        message.success('匯出成功');
      },
    }
  );
}

export function useExportProviderStatement() {
  return useMutation(
    ['enterpriseOrders', 'export'],
    (data: { id: string; name: string; date: string }) => {
      return axios
        .get(`/enterprise-orders/${data.id}/export-provider-statement`, {
          responseType: 'blob',
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute(
            'download',
            `${data.date} ${data.name}廠商對帳單.zip`
          ); // 指定下載的檔名

          document.body.appendChild(link);

          link.click();
          link.remove();

          window.URL.revokeObjectURL(url);
        });
    },
    {
      onError: async (error: any) => {
        if (error?.response?.data) {
          const errorData: any = JSON.parse(await error?.response?.data.text());

          message.error(errorData.message);
        }
      },
    }
  );
}
